import React, { Component } from 'react'
import DatePicker from 'react-datepicker'
import MaskInput from 'react-text-mask'
import moment from 'moment'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import './styles.scss'
import '../../styles/index.scss'

class FAADatePicker extends Component {
  handleOnChange (name, fieldValue) {
    this.props.Store.updateFieldValue(name, fieldValue)
    const currentDate = this.props.Store.getValue(name)
    this.props.Store.updateFieldError(name, !moment(currentDate).isValid() || moment(currentDate).diff(moment('01/01/1753')) < 0)
  }

  render () {
    const {
      name,
      title,
      placeholderText,
      automationName,
      Store
    } = this.props

    const currentDate = moment()
    const errorClass = Store.hasError(name) ? 'error' : ''
    const componentClasses = `form-control date-elm ${errorClass}`
    const datePickerWrapperClass = `datePickerWrapper ${errorClass}`
    const selectedValue = moment(Store.getValue(name), 'MM/DD/YYYY', true).isValid() ? Store.getValue(name) : null
    const customInput = <MaskInput mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]} />

    return (
      <div
        data-automation-name={automationName}
        className={datePickerWrapperClass}
      >
        <label className='sr-only'>{title}</label>
        <DatePicker
          selected={selectedValue}
          className={componentClasses}
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode='scroll'
          placeholderText={placeholderText}
          dateFormat='MM/dd/yyyy'
          customInput={customInput}
          maxDate={currentDate}
          name={name}
          onChange={value => this.handleOnChange(name, value)}
        />
      </div>
    )
  }
}

FAADatePicker.propTypes = {
  Store: PropTypes.object.isRequired
}

export default observer(FAADatePicker)
